import { render, staticRenderFns } from "./Canale.vue?vue&type=template&id=2e96fdfb&"
import script from "./Canale.vue?vue&type=script&lang=js&"
export * from "./Canale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports